export const AIRPORT_OPTIONS = [
  { code: 'ATL', city: 'Atlanta', name: 'Hartsfield–Jackson Atlanta International' },
  { code: 'AUS', city: 'Austin', name: 'Austin–Bergstrom International' },
  { code: 'BOS', city: 'Boston', name: 'Logan International' },
  { code: 'BWI', city: 'Baltimore', name: 'Baltimore/Washington International' },
  { code: 'CLT', city: 'Charlotte', name: 'Charlotte Douglas International' },
  { code: 'DCA', city: 'Washington, D.C.', name: 'Ronald Reagan Washington National' },
  { code: 'DEN', city: 'Denver', name: 'Denver International' },
  { code: 'DFW', city: 'Dallas', name: 'Dallas Fort Worth International' },
  { code: 'EWR', city: 'Newark', name: 'Newark Liberty International' },
  { code: 'FLL', city: 'Fort Lauderdale', name: 'Fort Lauderdale–Hollywood International' },
  { code: 'HNL', city: 'Honolulu', name: 'Daniel K. Inouye International' },
  { code: 'IAD', city: 'Washington, D.C.', name: 'Washington Dulles International' },
  { code: 'IAH', city: 'Houston', name: 'George Bush Intercontinental' },
  { code: 'JFK', city: 'New York', name: 'John F. Kennedy International' },
  { code: 'LAS', city: 'Las Vegas', name: 'Harry Reid International' },
  { code: 'LAX', city: 'Los Angeles', name: 'Los Angeles International' },
  { code: 'LGA', city: 'New York', name: 'LaGuardia Airport' },
  { code: 'MCO', city: 'Orlando', name: 'Orlando International' },
  { code: 'MIA', city: 'Miami', name: 'Miami International' },
  { code: 'MSP', city: 'Minneapolis', name: 'Minneapolis–Saint Paul International' },
  { code: 'ORD', city: 'Chicago', name: "O'Hare International" },
  { code: 'PDX', city: 'Portland', name: 'Portland International' },
  { code: 'PHL', city: 'Philadelphia', name: 'Philadelphia International' },
  { code: 'PHX', city: 'Phoenix', name: 'Phoenix Sky Harbor International' },
  { code: 'SAN', city: 'San Diego', name: 'San Diego International' },
  { code: 'SEA', city: 'Seattle', name: 'Seattle–Tacoma International' },
  { code: 'SFO', city: 'San Francisco', name: 'San Francisco International' },
  { code: 'SLC', city: 'Salt Lake City', name: 'Salt Lake City International' },
  { code: 'TPA', city: 'Tampa', name: 'Tampa International' },
];

export function airportValue(airport) {
  return `${airport.city} (${airport.code})`;
}

export function airportCode(value, fallback = 'ANY') {
  return value.match(/\(([A-Z]{3})\)/)?.[1] || value.match(/\b[A-Z]{3}\b/)?.[0] || fallback;
}
